import strFunc from "@/lib/lyg/string";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function ListArea(props: any) {
  let myProps = {
    infoArr: [],
    xColumnArr: {},
    listOpt: {},
    list: (inData: any) => { },
    ...props
  };

  let xColumnArr = myProps.xColumnArr;
  let infoArr = myProps.infoArr;
  let select_stu_grade_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade2' });

  const on_click_th_order = (key: string) => {
    let able_order_key_arr=["row_tot","complete_cnt","a_star_cnt","a_teacher_star","row_tot_star"];
    if(strFunc.str_in_array(key,able_order_key_arr)==-1){
      return false;
    }
    let order_key = myProps.listOpt.order_key;
    let up_down = myProps.listOpt.up_down;
    if (order_key === key) {
      if (up_down === "down") {
        up_down = "up";
      } else {
        up_down = "down";
      }
    } else {
      order_key = key;
      up_down = "down";
    }
    myProps.list({
      order_key: order_key,
      up_down: up_down,
    });
  };

  const get_tr_tags = () => {
    let tr_tags = infoArr.map((info: any, idx: number) => {
      return (
        <tr key={idx}>
          {xColumnArr.x_column_list_arr.map((column: any, col_idx: number) => {
            if (column.is_show != "1") {
              return null;
            }
            let render_str: any = "";
            let key = column.key;
            if (info[key]) {
              render_str = info[key];
            }

            if (key == "a_user_name") {
              if (info.stu_info) {
                render_str = info.stu_info.a_user_name;
                let row_stu_grade = "";
                for (let s_i = 0; s_i < select_stu_grade_option_arr.length; s_i++) {
                  let select_option = select_stu_grade_option_arr[s_i];
                  if (select_option.value == info.stu_info.a_stu_grade) {
                    row_stu_grade = select_option.text;
                  }
                }
                render_str += " " + row_stu_grade;
              }
            } else if (key == "row_tot_star") {
              render_str = strFunc.comma(render_str);
            }

            return (
              <td key={col_idx} className="text-center">
                {render_str}
              </td>
            );
          })}
        </tr>
      );
    });

    return tr_tags;
  };

  return (
    <div className="list-table-div">
      <table>
        <colgroup>
          {xColumnArr.x_column_list_arr.map((column: any, idx: number) => {
            if (column.is_show != "1") {
              return null;
            }
            return (
              <col key={idx} width={column.width}></col>
            );
          })}
        </colgroup>
        <thead>
          <tr>
            {xColumnArr.x_column_list_arr.map((column: any, idx: number) => {
              if (column.is_show != "1") {
                return null;
              }
              return (
                <th key={idx} onClick={() => {
                  on_click_th_order(column.key);
                }}>{column.name}</th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {get_tr_tags()}
        </tbody>
      </table>
    </div>
  );
};
export default ListArea;